export default __webpack_public_path__ + "static/media/hearted.778c8a63.svg";